export const tabletWidth = 992
export const maxFileSize = 5000000
